import React from "react";
import { FaSearch } from "react-icons/fa";
import "./style.css";
import { useState } from "react";
import { scrollxLogoBlack } from "../../../assets/icons";

const Navbar = ({ isSearchOpen, setIsSearchOpen }) => {
  return (
    <div className="w-full text-[#1a1b1e] border-b-[1px] border-[#e5e7ea] items-center h-full flex">
    <section className=" w-full flex items-center h-full">
      <div className="flex items-center  w-[21.1%]">
        <img className="w-[50px] h-[50px]  " src={scrollxLogoBlack} />
        <span className="Syne700 text-xl font-extrabold tracking-wide ">
          ScrollX.io
        </span>
      </div>
      {/* <div className="flex items-center justify-center w-16 h-full FontFamily-Avenir tracking-wider cursor-pointer text-[13px] leading-5 border-b  border-[#57a5e0]">
        <div>Docs</div>
      </div> */}
    </section>
    <section className="px-5 flex-1 flex justify-end">
      <div
        onClick={() => setIsSearchOpen(!isSearchOpen)}
        className="flex items-center gap-2 text-[#747474] border w-[16rem] px-3 py-[0.4rem] rounded cursor-pointer active:border-2 active:border-sky-700"
      >
        <FaSearch className="text-[0.8rem] " />
        <span className="text-[0.9rem]">Search</span>
      </div>
    </section>
  </div>
  );
};

export default Navbar;
